import { areaData } from './areaData'
const transferData = function (areaData) {
	const childNode = {}
	areaData.forEach(item => {
		childNode[item.code] = []
		item.child.forEach(childItem => {
			childNode[item.code].push(childItem.code)
			childItem.child.forEach(_childItem => {
				childNode[item.code].push(_childItem.code)
			})
		})
	})
	return childNode
}
export const childNode = transferData(areaData)
